// Do not edit this file, it is auto-generated at build time!
/* eslint-disable @typescript-eslint/no-explicit-any */
import { lazy, createElement, Fragment } from 'react';

const AnnouncementAlertBlock = lazy(() =>
  import('../components/blocks/AnnouncementAlertBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const BannerBlock = lazy(() =>
  import('../components/blocks/BannerBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const BundleBlock = lazy(() =>
  import('../components/blocks/BundleBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const CTABlock = lazy(() =>
  import('../components/blocks/CTABlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const CalloutBlock = lazy(() =>
  import('../components/blocks/CalloutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const CartPageIMUpsellBlock = lazy(() =>
  import('../components/blocks/CartPageIMUpsellBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const CartPanelIMUpsellBlock = lazy(() =>
  import('../components/blocks/CartPanelIMUpsellBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const CheckoutFooterBlock = lazy(() =>
  import('../components/blocks/CheckoutFooterBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const ContentGridBlock = lazy(() =>
  import('../components/blocks/ContentGridBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const CustomJsScript = lazy(() =>
  import('../components/blocks/CustomJsScript').then(module => ({
    default: (module as any)?.default || module
  }))
);
const CustomPressReleaseListBlock = lazy(() =>
  import('../components/blocks/CustomPressReleaseListBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const DisclaimerTextBlock = lazy(() =>
  import('../components/blocks/DisclaimerTextBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const DismissableBannerBlock = lazy(() =>
  import('../components/blocks/DismissableBannerBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const EditorialCalloutBlock = lazy(() =>
  import('../components/blocks/EditorialCalloutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const EditorialModuleContainerBlock = lazy(() =>
  import('../components/blocks/EditorialModuleContainerBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const EditorialToutWithImageBlock = lazy(() =>
  import('../components/blocks/EditorialToutWithImageBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const FacultyBioBlock = lazy(() =>
  import('../components/blocks/FacultyBioBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const FacultyGridBlock = lazy(() =>
  import('../components/blocks/FacultyGridBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
import * as FeaturedContentBlock from '../components/blocks/FeaturedContentBlock';
const FeaturedContentWideBlock = lazy(() =>
  import('../components/blocks/FeaturedContentWideBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const FeaturedGuests = lazy(() =>
  import('../components/blocks/FeaturedGuests').then(module => ({
    default: (module as any)?.default || module
  }))
);
const FindAProgramBlock = lazy(() =>
  import('../components/blocks/FindAProgramBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const GenericVideoBlock = lazy(() =>
  import('../components/blocks/GenericVideoBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IconBlock = lazy(() =>
  import('../components/blocks/IconBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IconMessageBlock = lazy(() =>
  import('../components/blocks/IconMessageBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IconOrStatsCardBlock = lazy(() =>
  import('../components/blocks/IconOrStatsCardBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const ImageMediaData = lazy(() =>
  import('../components/blocks/ImageMediaData').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IndividualMembershipDwellBlock = lazy(() =>
  import('../components/blocks/IndividualMembershipDwellBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const LayoutSettings = lazy(() =>
  import('../components/blocks/LayoutSettings').then(module => ({
    default: (module as any)?.default || module
  }))
);
const LightboxModal = lazy(() =>
  import('../components/blocks/LightboxModal').then(module => ({
    default: (module as any)?.default || module
  }))
);
const LocationsRowBlock = lazy(() =>
  import('../components/blocks/LocationsRowBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const MissionBlock = lazy(() =>
  import('../components/blocks/MissionBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
import * as PageIntroBlock from '../components/blocks/PageIntroBlock';
const PlusDwellBlock = lazy(() =>
  import('../components/blocks/PlusDwellBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PodcastSeriesBlock = lazy(() =>
  import('../components/blocks/PodcastSeriesBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PracticeAreaTickerBlock = lazy(() =>
  import('../components/blocks/PracticeAreaTickerBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PressReleaseListBlock = lazy(() =>
  import('../components/blocks/PressReleaseListBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const ProductSubBlock = lazy(() =>
  import('../components/blocks/ProductSubBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const ProgressiveOnboardingExperienceContainerBlock = lazy(() =>
  import('../components/blocks/ProgressiveOnboardingExperienceContainerBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PublicationTableOfContent = lazy(() =>
  import('../components/blocks/PublicationTableOfContent').then(module => ({
    default: (module as any)?.default || module
  }))
);
const QuoteCarousel = lazy(() =>
  import('../components/blocks/QuoteCarousel').then(module => ({
    default: (module as any)?.default || module
  }))
);
const RequestAQuoteModalBlock = lazy(() =>
  import('../components/blocks/RequestAQuoteModalBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const RichTextBlock = lazy(() =>
  import('../components/blocks/RichTextBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const RssContentBlock = lazy(() =>
  import('../components/blocks/RssContentBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const SearchFindAProgramButtonsBlock = lazy(() =>
  import('../components/blocks/SearchFindAProgramButtonsBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const SearchResultBlock = lazy(() =>
  import('../components/blocks/SearchResultBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const StandardWhiteHeaderBlock = lazy(() =>
  import('../components/blocks/StandardWhiteHeaderBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const StartTrialModalBlock = lazy(() =>
  import('../components/blocks/StartTrialModalBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const StsExpirationAdBlock = lazy(() =>
  import('../components/blocks/StsExpirationAdBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const SubnavBlock = lazy(() =>
  import('../components/blocks/SubnavBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const SubscriptionBlock = lazy(() =>
  import('../components/blocks/SubscriptionBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
import * as WalkthroughExperienceModalBlock from '../components/blocks/WalkthroughExperienceModalBlock';
const AccordionContainerBlock = lazy(() =>
  import('../components/blocks/Accordion/AccordionContainerBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const AccordionItemBlock = lazy(() =>
  import('../components/blocks/Accordion/AccordionItemBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const AccordionLinkBlock = lazy(() =>
  import('../components/blocks/Accordion/AccordionLinkBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const AccordionLinkItem = lazy(() =>
  import('../components/blocks/Accordion/AccordionLinkItem').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IconLinkBlock = lazy(() =>
  import('../components/blocks/Accordion/IconLinkBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const BasicContentRow = lazy(() =>
  import('../components/blocks/BasicContentRowContainerBlock/BasicContentRow').then(module => ({
    default: (module as any)?.default || module
  }))
);
import * as BasicContentRowContainerBlock from '../components/blocks/BasicContentRowContainerBlock/BasicContentRowContainerBlock';
const FeaturedCardLayout = lazy(() =>
  import('../components/blocks/Collections/FeaturedCardLayout').then(module => ({
    default: (module as any)?.default || module
  }))
);
const FeaturedCollectionsBlock = lazy(() =>
  import('../components/blocks/Collections/FeaturedCollectionsBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const BannerMessageBlock = lazy(() =>
  import('../components/blocks/CreditInfo/BannerMessageBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const BrowseByCreditBlock = lazy(() =>
  import('../components/blocks/CreditInfo/BrowseByCreditBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const UserJurisdictionsBlock = lazy(() =>
  import('../components/blocks/CreditInfo/UserJurisdictionsBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const useCreditInfoHook = lazy(() =>
  import('../components/blocks/CreditInfo/hooks/useCreditInfoHook').then(module => ({
    default: (module as any)?.default || module
  }))
);
const CreditClassContent = lazy(() =>
  import('../components/blocks/CreditInfo/snippets/CreditClassContent').then(module => ({
    default: (module as any)?.default || module
  }))
);
const CreditInfoAccordionItem = lazy(() =>
  import('../components/blocks/CreditInfo/snippets/CreditInfoAccordionItem').then(module => ({
    default: (module as any)?.default || module
  }))
);
const CreditInfoAccordionSection = lazy(() =>
  import('../components/blocks/CreditInfo/snippets/CreditInfoAccordionSection').then(module => ({
    default: (module as any)?.default || module
  }))
);
const CreditInfoHeader = lazy(() =>
  import('../components/blocks/CreditInfo/snippets/CreditInfoHeader').then(module => ({
    default: (module as any)?.default || module
  }))
);
const CreditInfoOverview = lazy(() =>
  import('../components/blocks/CreditInfo/snippets/CreditInfoOverview').then(module => ({
    default: (module as any)?.default || module
  }))
);
const JurisdictionHeaderRequirementMessage = lazy(() =>
  import('../components/blocks/CreditInfo/snippets/JurisdictionHeaderRequirementMessage').then(
    module => ({ default: (module as any)?.default || module })
  )
);
const LoadingShimmers = lazy(() =>
  import('../components/blocks/CreditInfo/snippets/LoadingShimmers').then(module => ({
    default: (module as any)?.default || module
  }))
);
const CreditPlanBlock = lazy(() =>
  import('../components/blocks/CreditPlan/CreditPlanBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const CreditOverviewBlock = lazy(() =>
  import('../components/blocks/CreditTracker/CreditOverviewBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const CreditTrackerContext = lazy(() =>
  import('../components/blocks/CreditTracker/CreditTrackerContext').then(module => ({
    default: (module as any)?.default || module
  }))
);
const MiniTrackerBlock = lazy(() =>
  import('../components/blocks/CreditTracker/MiniTrackerBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const MemsuiteHeaderBlock = lazy(() =>
  import('../components/blocks/CreditTrackerAdmin/MemsuiteHeaderBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const AddLicenseBlock = lazy(() =>
  import('../components/blocks/EmptyStateBlock/AddLicenseBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const EmptyStateBlock = lazy(() =>
  import('../components/blocks/EmptyStateBlock/EmptyStateBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const withPliErrorBoundary = lazy(() =>
  import('../components/blocks/ErrorBoundary/withPliErrorBoundary').then(module => ({
    default: (module as any)?.default || module
  }))
);
const ComponentFailurePlaceholderBlock = lazy(() =>
  import('../components/blocks/ErrorFallback/ComponentFailurePlaceholderBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const ComponentFallback = lazy(() =>
  import('../components/blocks/ErrorFallback/ComponentFallback').then(module => ({
    default: (module as any)?.default || module
  }))
);
const EcommBoxWithErrorBoundary = lazy(() =>
  import('../components/blocks/ErrorFallback/EcommBoxWithErrorBoundary').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PanelContentWithErrorBoundary = lazy(() =>
  import('../components/blocks/ErrorFallback/PanelContentWithErrorBoundary').then(module => ({
    default: (module as any)?.default || module
  }))
);
const StaticFooterFallback = lazy(() =>
  import('../components/blocks/ErrorFallback/StaticFooterFallback').then(module => ({
    default: (module as any)?.default || module
  }))
);
const StaticHeaderFallback = lazy(() =>
  import('../components/blocks/ErrorFallback/StaticHeaderFallback').then(module => ({
    default: (module as any)?.default || module
  }))
);
const FacultyMemberBlock = lazy(() =>
  import('../components/blocks/FacultyRowContainer/FacultyMemberBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const FacultyRowContainerBlock = lazy(() =>
  import('../components/blocks/FacultyRowContainer/FacultyRowContainerBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const AddLicenseStep = lazy(() =>
  import('../components/blocks/FinishProfileBlock/AddLicenseStep').then(module => ({
    default: (module as any)?.default || module
  }))
);
const FinishProfileBlock = lazy(() =>
  import('../components/blocks/FinishProfileBlock/FinishProfileBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const MultiStepModalBlock = lazy(() =>
  import('../components/blocks/FinishProfileBlock/MultiStepModalBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PracticeAreaStep = lazy(() =>
  import('../components/blocks/FinishProfileBlock/PracticeAreaStep').then(module => ({
    default: (module as any)?.default || module
  }))
);
const RolesStep = lazy(() =>
  import('../components/blocks/FinishProfileBlock/RolesStep').then(module => ({
    default: (module as any)?.default || module
  }))
);
import * as FooterBlock from '../components/blocks/Footer/FooterBlock';
const FooterLinkListBlock = lazy(() =>
  import('../components/blocks/Footer/FooterLinkListBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
import * as FooterNav from '../components/blocks/Footer/FooterNav';
import * as GlobalBannerBlock from '../components/blocks/GlobalBanner/GlobalBannerBlock';
import * as GlobalBannerHeader from '../components/blocks/GlobalBanner/GlobalBannerHeader';
import * as GlobalBannerPanel from '../components/blocks/GlobalBanner/GlobalBannerPanel';
import * as HeaderBlock from '../components/blocks/Header/HeaderBlock';
const NavigationItemBlock = lazy(() =>
  import('../components/blocks/Header/NavigationItemBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
import * as PanelAccountNavMobile from '../components/blocks/Header/PanelAccountNavMobile';
import * as PanelAccountNavTablet from '../components/blocks/Header/PanelAccountNavTablet';
import * as PanelNavMobile from '../components/blocks/Header/PanelNavMobile';
import * as PanelNavTablet from '../components/blocks/Header/PanelNavTablet';
const SubnavigationItemBlock = lazy(() =>
  import('../components/blocks/Header/SubnavigationItemBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const EditorialSlideBlock = lazy(() =>
  import('../components/blocks/HomePageCarousel/EditorialSlideBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const FullSizeSlideBlock = lazy(() =>
  import('../components/blocks/HomePageCarousel/FullSizeSlideBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
import * as HomePageCarousel from '../components/blocks/HomePageCarousel/HomePageCarousel';
const LiveNowSlideBlock = lazy(() =>
  import('../components/blocks/HomePageCarousel/LiveNowSlideBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const LiveSliceBlock = lazy(() =>
  import('../components/blocks/HomePageCarousel/LiveSliceBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const OnDemandSliceBlock = lazy(() =>
  import('../components/blocks/HomePageCarousel/OnDemandSliceBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PodcastProgramSlide = lazy(() =>
  import('../components/blocks/HomePageCarousel/PodcastProgramSlide').then(module => ({
    default: (module as any)?.default || module
  }))
);
const TwoUpSlideBlock = lazy(() =>
  import('../components/blocks/HomePageCarousel/TwoUpSlideBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const InteractiveEditorialBlock = lazy(() =>
  import('../components/blocks/ILC/InteractiveEditorialBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const InteractiveEditorialBlockItem = lazy(() =>
  import('../components/blocks/ILC/InteractiveEditorialBlockItem').then(module => ({
    default: (module as any)?.default || module
  }))
);
import * as LargeCarouselContainerBlock from '../components/blocks/LargeCarousel/LargeCarouselContainerBlock';
import * as LargeCarouselSlideFifty from '../components/blocks/LargeCarousel/LargeCarouselSlideFifty';
const LargeCarouselSlideFull = lazy(() =>
  import('../components/blocks/LargeCarousel/LargeCarouselSlideFull').then(module => ({
    default: (module as any)?.default || module
  }))
);
const LargeCarouselSlideGallery = lazy(() =>
  import('../components/blocks/LargeCarousel/LargeCarouselSlideGallery').then(module => ({
    default: (module as any)?.default || module
  }))
);
const MyLibraryBlock = lazy(() =>
  import('../components/blocks/Library/MyLibraryBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const FacultyLinkBlock = lazy(() =>
  import('../components/blocks/LinkGridBlock/FacultyLinkBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const JavascriptLinkBlock = lazy(() =>
  import('../components/blocks/LinkGridBlock/JavascriptLinkBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const LinkBlock = lazy(() =>
  import('../components/blocks/LinkGridBlock/LinkBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const LinkGridBlock = lazy(() =>
  import('../components/blocks/LinkGridBlock/LinkGridBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const LinkGridBlockCollapsible = lazy(() =>
  import('../components/blocks/LinkGridBlock/LinkGridBlockCollapsible').then(module => ({
    default: (module as any)?.default || module
  }))
);
const LinkGridBlockContent = lazy(() =>
  import('../components/blocks/LinkGridBlock/LinkGridBlockContent').then(module => ({
    default: (module as any)?.default || module
  }))
);
const LinkGridBlockNonCollapsible = lazy(() =>
  import('../components/blocks/LinkGridBlock/LinkGridBlockNonCollapsible').then(module => ({
    default: (module as any)?.default || module
  }))
);
const TextLinkBlock = lazy(() =>
  import('../components/blocks/LinkGridBlock/TextLinkBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const BrandHeaderBlock = lazy(() =>
  import('../components/blocks/Masthead/BrandHeaderBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const ImpactHeaderBlock = lazy(() =>
  import('../components/blocks/Masthead/ImpactHeaderBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const SignatureHeaderBlock = lazy(() =>
  import('../components/blocks/Masthead/SignatureHeaderBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const StandardBlackHeaderBlock = lazy(() =>
  import('../components/blocks/Masthead/StandardBlackHeaderBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const StandardGrayHeaderBlock = lazy(() =>
  import('../components/blocks/Masthead/StandardGrayHeaderBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IPDPContentLayoutBlock = lazy(() =>
  import('../components/blocks/PDP/IPDPContentLayoutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IPDPOverviewLayoutBlock = lazy(() =>
  import('../components/blocks/PDP/IPDPOverviewLayoutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IPDPProgramCreditLayoutBlock = lazy(() =>
  import('../components/blocks/PDP/IPDPProgramCreditLayoutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IPDPProgramFacultyLayoutBlock = lazy(() =>
  import('../components/blocks/PDP/IPDPProgramFacultyLayoutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IPDPProgramLocationDetailsLayoutBlock = lazy(() =>
  import('../components/blocks/PDP/IPDPProgramLocationDetailsLayoutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IPDPProgramScheduleLayoutBlock = lazy(() =>
  import('../components/blocks/PDP/IPDPProgramScheduleLayoutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IPDPProgramSegmentsLayoutBlock = lazy(() =>
  import('../components/blocks/PDP/IPDPProgramSegmentsLayoutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IPDPTestimonialsLayoutBlock = lazy(() =>
  import('../components/blocks/PDP/IPDPTestimonialsLayoutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IPDPTopicsAndIndustriesLayoutBlock = lazy(() =>
  import('../components/blocks/PDP/IPDPTopicsAndIndustriesLayoutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const KeyTakewayLayoutBlock = lazy(() =>
  import('../components/blocks/PDP/KeyTakewayLayoutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const TimedAgendaBlock = lazy(() =>
  import('../components/blocks/PDP/TimedAgendaBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IPDPAdditionalInfo1LayoutBlock = lazy(() =>
  import('../components/blocks/PDP/overview/IPDPAdditionalInfo1LayoutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IPDPAdditionalInfo2LayoutBlock = lazy(() =>
  import('../components/blocks/PDP/overview/IPDPAdditionalInfo2LayoutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IPDPAdditionalInfo3LayoutBlock = lazy(() =>
  import('../components/blocks/PDP/overview/IPDPAdditionalInfo3LayoutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IPDPProgramAnnouncementsLayoutBlock = lazy(() =>
  import('../components/blocks/PDP/overview/IPDPProgramAnnouncementsLayoutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IPDPSpecialFeaturesLayoutBlock = lazy(() =>
  import('../components/blocks/PDP/overview/IPDPSpecialFeaturesLayoutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IPDPWhatYouWillLearnLayoutBlock = lazy(() =>
  import('../components/blocks/PDP/overview/IPDPWhatYouWillLearnLayoutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IPDPWhoShouldAttendLayoutLayoutBlock = lazy(() =>
  import('../components/blocks/PDP/overview/IPDPWhoShouldAttendLayoutLayoutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const IPDPWhyYouShouldAttendLayoutBlock = lazy(() =>
  import('../components/blocks/PDP/overview/IPDPWhyYouShouldAttendLayoutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PodcastListingBlock = lazy(() =>
  import('../components/blocks/PodcastListingBlock/PodcastListingBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PodcastListingContent = lazy(() =>
  import('../components/blocks/PodcastListingBlock/PodcastListingContent').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PodcastListingSingle = lazy(() =>
  import('../components/blocks/PodcastListingBlock/PodcastListingSingle').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PracticeAreaMasthead = lazy(() =>
  import('../components/blocks/PracticeArea/PracticeAreaMasthead').then(module => ({
    default: (module as any)?.default || module
  }))
);
const SecondaryTaxonomyBlock = lazy(() =>
  import('../components/blocks/PracticeArea/SecondaryTaxonomyBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const SecondaryTaxonomyBlockShimmer = lazy(() =>
  import('../components/blocks/PracticeArea/SecondaryTaxonomyBlockShimmer').then(module => ({
    default: (module as any)?.default || module
  }))
);
const ManageAccountBlock = lazy(() =>
  import('../components/blocks/Profile/ManageAccountBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const OrderHistoryBlock = lazy(() =>
  import('../components/blocks/Profile/OrderHistoryBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PaymentsCardsBlock = lazy(() =>
  import('../components/blocks/Profile/PaymentsCardsBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PersonalInfoAboutBlock = lazy(() =>
  import('../components/blocks/Profile/PersonalInfoAboutBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PersonalInfoAddressesBlock = lazy(() =>
  import('../components/blocks/Profile/PersonalInfoAddressesBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PersonalInfoContactInfoBlock = lazy(() =>
  import('../components/blocks/Profile/PersonalInfoContactInfoBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PersonalInfoFacultyBlock = lazy(() =>
  import('../components/blocks/Profile/PersonalInfoFacultyBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PersonalInfoIndustriesBlock = lazy(() =>
  import('../components/blocks/Profile/PersonalInfoIndustriesBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PersonalInfoLoginDetailsBlock = lazy(() =>
  import('../components/blocks/Profile/PersonalInfoLoginDetailsBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PersonalInfoPracticeAreasBlock = lazy(() =>
  import('../components/blocks/Profile/PersonalInfoPracticeAreasBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const PreferencesCommunicationBlock = lazy(() =>
  import('../components/blocks/Profile/PreferencesCommunicationBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const POECTabsContainerBlock = lazy(() =>
  import('../components/blocks/Tabs/POECTabsContainerBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const TabBlock = lazy(() =>
  import('../components/blocks/Tabs/TabBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const TabsContainerBlock = lazy(() =>
  import('../components/blocks/Tabs/TabsContainerBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const TaxonomyItem = lazy(() =>
  import('../components/blocks/Tabs/TaxonomyItem').then(module => ({
    default: (module as any)?.default || module
  }))
);
const TaxonomyTabContainerBlock = lazy(() =>
  import('../components/blocks/Tabs/TaxonomyTabContainerBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const TaxonomyTabItemBlock = lazy(() =>
  import('../components/blocks/Tabs/TaxonomyTabItemBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const CTAIconSubBlock = lazy(() =>
  import('../components/blocks/Tiles/CTAIconSubBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const ImageSubBlock = lazy(() =>
  import('../components/blocks/Tiles/ImageSubBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const LongTileSubBlock = lazy(() =>
  import('../components/blocks/Tiles/LongTileSubBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const MembersRowCollapsible = lazy(() =>
  import('../components/blocks/Tiles/MembersRowCollapsible').then(module => ({
    default: (module as any)?.default || module
  }))
);
const MembersRowNonCollapsible = lazy(() =>
  import('../components/blocks/Tiles/MembersRowNonCollapsible').then(module => ({
    default: (module as any)?.default || module
  }))
);
const TileBlock = lazy(() =>
  import('../components/blocks/Tiles/TileBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const TileCarouselBlock = lazy(() =>
  import('../components/blocks/Tiles/TileCarouselBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const TimelineCarouselContainerBlock = lazy(() =>
  import('../components/blocks/TimelineCarouselBlock/TimelineCarouselContainerBlock').then(
    module => ({ default: (module as any)?.default || module })
  )
);
const TimelineSlideBlock = lazy(() =>
  import('../components/blocks/TimelineCarouselBlock/TimelineSlideBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
import * as TooltipBlock from '../components/blocks/Tooltip/TooltipBlock';
const GenericContentCardBlock = lazy(() =>
  import('../components/blocks/TwoUpBlock/GenericContentCardBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);
const TwoUpBlock = lazy(() =>
  import('../components/blocks/TwoUpBlock/TwoUpBlock').then(module => ({
    default: (module as any)?.default || module
  }))
);

const components = new Map();

components.set('AnnouncementAlertBlock', AnnouncementAlertBlock);
components.set('BannerBlock', BannerBlock);
components.set('BundleBlock', BundleBlock);
components.set('CTABlock', CTABlock);
components.set('CalloutBlock', CalloutBlock);
components.set('CartPageIMUpsellBlock', CartPageIMUpsellBlock);
components.set('CartPanelIMUpsellBlock', CartPanelIMUpsellBlock);
components.set('CheckoutFooterBlock', CheckoutFooterBlock);
components.set('ContentGridBlock', ContentGridBlock);
components.set('CustomJsScript', CustomJsScript);
components.set('CustomPressReleaseListBlock', CustomPressReleaseListBlock);
components.set('DisclaimerTextBlock', DisclaimerTextBlock);
components.set('DismissableBannerBlock', DismissableBannerBlock);
components.set('EditorialCalloutBlock', EditorialCalloutBlock);
components.set('EditorialModuleContainerBlock', EditorialModuleContainerBlock);
components.set('EditorialToutWithImageBlock', EditorialToutWithImageBlock);
components.set('FacultyBioBlock', FacultyBioBlock);
components.set('FacultyGridBlock', FacultyGridBlock);
components.set('FeaturedContentBlock', FeaturedContentBlock);
components.set('FeaturedContentWideBlock', FeaturedContentWideBlock);
components.set('FeaturedGuests', FeaturedGuests);
components.set('FindAProgramBlock', FindAProgramBlock);
components.set('GenericVideoBlock', GenericVideoBlock);
components.set('IconBlock', IconBlock);
components.set('IconMessageBlock', IconMessageBlock);
components.set('IconOrStatsCardBlock', IconOrStatsCardBlock);
components.set('ImageMediaData', ImageMediaData);
components.set('IndividualMembershipDwellBlock', IndividualMembershipDwellBlock);
components.set('LayoutSettings', LayoutSettings);
components.set('LightboxModal', LightboxModal);
components.set('LocationsRowBlock', LocationsRowBlock);
components.set('MissionBlock', MissionBlock);
components.set('PageIntroBlock', PageIntroBlock);
components.set('PlusDwellBlock', PlusDwellBlock);
components.set('PodcastSeriesBlock', PodcastSeriesBlock);
components.set('PracticeAreaTickerBlock', PracticeAreaTickerBlock);
components.set('PressReleaseListBlock', PressReleaseListBlock);
components.set('ProductSubBlock', ProductSubBlock);
components.set(
  'ProgressiveOnboardingExperienceContainerBlock',
  ProgressiveOnboardingExperienceContainerBlock
);
components.set('PublicationTableOfContent', PublicationTableOfContent);
components.set('QuoteCarousel', QuoteCarousel);
components.set('RequestAQuoteModalBlock', RequestAQuoteModalBlock);
components.set('RichTextBlock', RichTextBlock);
components.set('RssContentBlock', RssContentBlock);
components.set('SearchFindAProgramButtonsBlock', SearchFindAProgramButtonsBlock);
components.set('SearchResultBlock', SearchResultBlock);
components.set('StandardWhiteHeaderBlock', StandardWhiteHeaderBlock);
components.set('StartTrialModalBlock', StartTrialModalBlock);
components.set('StsExpirationAdBlock', StsExpirationAdBlock);
components.set('SubnavBlock', SubnavBlock);
components.set('SubscriptionBlock', SubscriptionBlock);
components.set('WalkthroughExperienceModalBlock', WalkthroughExperienceModalBlock);
components.set('AccordionContainerBlock', AccordionContainerBlock);
components.set('AccordionItemBlock', AccordionItemBlock);
components.set('AccordionLinkBlock', AccordionLinkBlock);
components.set('AccordionLinkItem', AccordionLinkItem);
components.set('IconLinkBlock', IconLinkBlock);
components.set('BasicContentRow', BasicContentRow);
components.set('BasicContentRowContainerBlock', BasicContentRowContainerBlock);
components.set('FeaturedCardLayout', FeaturedCardLayout);
components.set('FeaturedCollectionsBlock', FeaturedCollectionsBlock);
components.set('BannerMessageBlock', BannerMessageBlock);
components.set('BrowseByCreditBlock', BrowseByCreditBlock);
components.set('UserJurisdictionsBlock', UserJurisdictionsBlock);
components.set('useCreditInfoHook', useCreditInfoHook);
components.set('CreditClassContent', CreditClassContent);
components.set('CreditInfoAccordionItem', CreditInfoAccordionItem);
components.set('CreditInfoAccordionSection', CreditInfoAccordionSection);
components.set('CreditInfoHeader', CreditInfoHeader);
components.set('CreditInfoOverview', CreditInfoOverview);
components.set('JurisdictionHeaderRequirementMessage', JurisdictionHeaderRequirementMessage);
components.set('LoadingShimmers', LoadingShimmers);
components.set('CreditPlanBlock', CreditPlanBlock);
components.set('CreditOverviewBlock', CreditOverviewBlock);
components.set('CreditTrackerContext', CreditTrackerContext);
components.set('MiniTrackerBlock', MiniTrackerBlock);
components.set('MemsuiteHeaderBlock', MemsuiteHeaderBlock);
components.set('AddLicenseBlock', AddLicenseBlock);
components.set('EmptyStateBlock', EmptyStateBlock);
components.set('withPliErrorBoundary', withPliErrorBoundary);
components.set('ComponentFailurePlaceholderBlock', ComponentFailurePlaceholderBlock);
components.set('ComponentFallback', ComponentFallback);
components.set('EcommBoxWithErrorBoundary', EcommBoxWithErrorBoundary);
components.set('PanelContentWithErrorBoundary', PanelContentWithErrorBoundary);
components.set('StaticFooterFallback', StaticFooterFallback);
components.set('StaticHeaderFallback', StaticHeaderFallback);
components.set('FacultyMemberBlock', FacultyMemberBlock);
components.set('FacultyRowContainerBlock', FacultyRowContainerBlock);
components.set('AddLicenseStep', AddLicenseStep);
components.set('FinishProfileBlock', FinishProfileBlock);
components.set('MultiStepModalBlock', MultiStepModalBlock);
components.set('PracticeAreaStep', PracticeAreaStep);
components.set('RolesStep', RolesStep);
components.set('FooterBlock', FooterBlock);
components.set('FooterLinkListBlock', FooterLinkListBlock);
components.set('FooterNav', FooterNav);
components.set('GlobalBannerBlock', GlobalBannerBlock);
components.set('GlobalBannerHeader', GlobalBannerHeader);
components.set('GlobalBannerPanel', GlobalBannerPanel);
components.set('HeaderBlock', HeaderBlock);
components.set('NavigationItemBlock', NavigationItemBlock);
components.set('PanelAccountNavMobile', PanelAccountNavMobile);
components.set('PanelAccountNavTablet', PanelAccountNavTablet);
components.set('PanelNavMobile', PanelNavMobile);
components.set('PanelNavTablet', PanelNavTablet);
components.set('SubnavigationItemBlock', SubnavigationItemBlock);
components.set('EditorialSlideBlock', EditorialSlideBlock);
components.set('FullSizeSlideBlock', FullSizeSlideBlock);
components.set('HomePageCarousel', HomePageCarousel);
components.set('LiveNowSlideBlock', LiveNowSlideBlock);
components.set('LiveSliceBlock', LiveSliceBlock);
components.set('OnDemandSliceBlock', OnDemandSliceBlock);
components.set('PodcastProgramSlide', PodcastProgramSlide);
components.set('TwoUpSlideBlock', TwoUpSlideBlock);
components.set('InteractiveEditorialBlock', InteractiveEditorialBlock);
components.set('InteractiveEditorialBlockItem', InteractiveEditorialBlockItem);
components.set('LargeCarouselContainerBlock', LargeCarouselContainerBlock);
components.set('LargeCarouselSlideFifty', LargeCarouselSlideFifty);
components.set('LargeCarouselSlideFull', LargeCarouselSlideFull);
components.set('LargeCarouselSlideGallery', LargeCarouselSlideGallery);
components.set('MyLibraryBlock', MyLibraryBlock);
components.set('FacultyLinkBlock', FacultyLinkBlock);
components.set('JavascriptLinkBlock', JavascriptLinkBlock);
components.set('LinkBlock', LinkBlock);
components.set('LinkGridBlock', LinkGridBlock);
components.set('LinkGridBlockCollapsible', LinkGridBlockCollapsible);
components.set('LinkGridBlockContent', LinkGridBlockContent);
components.set('LinkGridBlockNonCollapsible', LinkGridBlockNonCollapsible);
components.set('TextLinkBlock', TextLinkBlock);
components.set('BrandHeaderBlock', BrandHeaderBlock);
components.set('ImpactHeaderBlock', ImpactHeaderBlock);
components.set('SignatureHeaderBlock', SignatureHeaderBlock);
components.set('StandardBlackHeaderBlock', StandardBlackHeaderBlock);
components.set('StandardGrayHeaderBlock', StandardGrayHeaderBlock);
components.set('IPDPContentLayoutBlock', IPDPContentLayoutBlock);
components.set('IPDPOverviewLayoutBlock', IPDPOverviewLayoutBlock);
components.set('IPDPProgramCreditLayoutBlock', IPDPProgramCreditLayoutBlock);
components.set('IPDPProgramFacultyLayoutBlock', IPDPProgramFacultyLayoutBlock);
components.set('IPDPProgramLocationDetailsLayoutBlock', IPDPProgramLocationDetailsLayoutBlock);
components.set('IPDPProgramScheduleLayoutBlock', IPDPProgramScheduleLayoutBlock);
components.set('IPDPProgramSegmentsLayoutBlock', IPDPProgramSegmentsLayoutBlock);
components.set('IPDPTestimonialsLayoutBlock', IPDPTestimonialsLayoutBlock);
components.set('IPDPTopicsAndIndustriesLayoutBlock', IPDPTopicsAndIndustriesLayoutBlock);
components.set('KeyTakewayLayoutBlock', KeyTakewayLayoutBlock);
components.set('TimedAgendaBlock', TimedAgendaBlock);
components.set('IPDPAdditionalInfo1LayoutBlock', IPDPAdditionalInfo1LayoutBlock);
components.set('IPDPAdditionalInfo2LayoutBlock', IPDPAdditionalInfo2LayoutBlock);
components.set('IPDPAdditionalInfo3LayoutBlock', IPDPAdditionalInfo3LayoutBlock);
components.set('IPDPProgramAnnouncementsLayoutBlock', IPDPProgramAnnouncementsLayoutBlock);
components.set('IPDPSpecialFeaturesLayoutBlock', IPDPSpecialFeaturesLayoutBlock);
components.set('IPDPWhatYouWillLearnLayoutBlock', IPDPWhatYouWillLearnLayoutBlock);
components.set('IPDPWhoShouldAttendLayoutLayoutBlock', IPDPWhoShouldAttendLayoutLayoutBlock);
components.set('IPDPWhyYouShouldAttendLayoutBlock', IPDPWhyYouShouldAttendLayoutBlock);
components.set('PodcastListingBlock', PodcastListingBlock);
components.set('PodcastListingContent', PodcastListingContent);
components.set('PodcastListingSingle', PodcastListingSingle);
components.set('PracticeAreaMasthead', PracticeAreaMasthead);
components.set('SecondaryTaxonomyBlock', SecondaryTaxonomyBlock);
components.set('SecondaryTaxonomyBlockShimmer', SecondaryTaxonomyBlockShimmer);
components.set('ManageAccountBlock', ManageAccountBlock);
components.set('OrderHistoryBlock', OrderHistoryBlock);
components.set('PaymentsCardsBlock', PaymentsCardsBlock);
components.set('PersonalInfoAboutBlock', PersonalInfoAboutBlock);
components.set('PersonalInfoAddressesBlock', PersonalInfoAddressesBlock);
components.set('PersonalInfoContactInfoBlock', PersonalInfoContactInfoBlock);
components.set('PersonalInfoFacultyBlock', PersonalInfoFacultyBlock);
components.set('PersonalInfoIndustriesBlock', PersonalInfoIndustriesBlock);
components.set('PersonalInfoLoginDetailsBlock', PersonalInfoLoginDetailsBlock);
components.set('PersonalInfoPracticeAreasBlock', PersonalInfoPracticeAreasBlock);
components.set('PreferencesCommunicationBlock', PreferencesCommunicationBlock);
components.set('POECTabsContainerBlock', POECTabsContainerBlock);
components.set('TabBlock', TabBlock);
components.set('TabsContainerBlock', TabsContainerBlock);
components.set('TaxonomyItem', TaxonomyItem);
components.set('TaxonomyTabContainerBlock', TaxonomyTabContainerBlock);
components.set('TaxonomyTabItemBlock', TaxonomyTabItemBlock);
components.set('CTAIconSubBlock', CTAIconSubBlock);
components.set('ImageSubBlock', ImageSubBlock);
components.set('LongTileSubBlock', LongTileSubBlock);
components.set('MembersRowCollapsible', MembersRowCollapsible);
components.set('MembersRowNonCollapsible', MembersRowNonCollapsible);
components.set('TileBlock', TileBlock);
components.set('TileCarouselBlock', TileCarouselBlock);
components.set('TimelineCarouselContainerBlock', TimelineCarouselContainerBlock);
components.set('TimelineSlideBlock', TimelineSlideBlock);
components.set('TooltipBlock', TooltipBlock);
components.set('GenericContentCardBlock', GenericContentCardBlock);
components.set('TwoUpBlock', TwoUpBlock);

export function componentFactory(componentName: string) {
  const component = components.get(componentName);

  let renderer = component?.Default || component?.default || component;

  if (!renderer) {
    renderer = () => createElement(Fragment);
    renderer.displayName = componentName + '(Undefined)';
  }

  return renderer;
}
